$(document).ready(function()
{
    // Rating stars
    $(".CustRating").custRating();

    // Heading
    if ($(".heading").length > 0) {
        $('[tool-tip-toggle]').tooltip();
    }

    // Stars select
    $(".StarSelector-5 input").change(function() {
        var value = $(this).val();
        $(this).parent('.StarSelector-5').removeAttr('class').addClass('StarSelector StarSelector-5 stars-selected-' + value);
    });
    $(".StarSelector-10 input").change(function() {
        var value = $(this).val();
        $(this).parent('.StarSelector-10').removeAttr('class').addClass('StarSelector StarSelector-10 stars-selected-' + value);
    });

    // Date picker
    $('[data-toggle="datepicker"]').datepicker({
        autoHide: true,
        format: 'dd/mm/yyyy',
        language: AppLocale,
        endDate: '+1d',
        offset: -305,
        zIndex: 2048
    });

    $('[data-toggle="datepicker_field"]').datepicker({
        autoHide: true,
        format: 'dd/mm/yyyy',
        language: AppLocale,
        offset: -305,
        zIndex: 2048
    });

    // Attachments upload
    $("#AttachmentFileInput").change(function() {
        if ($('.item-attach').length >= 5) {
            $('#AttachmentErrors').append('<span class="text-red-700 mt-3 msg-error">'+ polyglot.t("attachment.error.max_files") +'</span>');
            return;
        }
        var allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
        var file = this.files[0];
        var fileType = file.type;
        if (!allowedTypes.includes(fileType)) {
            alert(polyglot.t("attachment.error.invalid_file_type"));
            $("#fileInput").val('');
            return false;
        }
        formData = new FormData();
        formData.append('file', file);
        formData.append('_token', $('input[name="_token"]').val());
        formData.append('collection_name', 'attachments');
        formData.append('brand_id', $('input[name="brand_id"]').val());
        $.ajax({
            type: 'POST',
            url: '/attachments',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            beforeSend: function() {
                $('#AttachmentFileInput').closest('.loadingEffect').toggleClass('run-action');
                $('form').find('[type="submit"]').prop('disabled', true);
            },
            error:function(xhr) {
                if (xhr.status == '422') {
                    $.each(xhr.responseJSON.errors, function(key, value) {
                        $('#AttachmentErrors').append('<span class="text-red-700 mt-3 block msg-error">'+value[0]+'</span>');
                    });
                }
                if (xhr.status == '413') {
                    $('#AttachmentErrors').append('<span class="text-red-700 mt-3 block msg-error">Error ! File too large</span>');
                }
            },
            success: function(resp) {
                if (resp.status === 'success') {
                    $("#AttachmentFiles").append(resp.view);
                    $('#AttachmentErrors > .msg-error').remove();
                }
                else {
                    $('#AttachmentErrors').append('<span class="text-red-700 mt-3 block msg-error">'+ resp.message +'</span>');
                }
            },
            complete: function() {
                $('#AttachmentFileInput').closest('.loadingEffect').toggleClass('run-action');
                $('form').find('[type="submit"]').prop('disabled', false);
            }
        });
    });
    // Generate review title
    $('#PublishBox textarea[name="message"]').keyup(function () {
        var message = $(this).val();
        message = message.split('\n', 1)[0];
        var title = message.length <= 50 ? message : message.replace(/^(.{50}[^\s]*).*/, "$1") + ' ...';
        $('#PublishBox input[name="subject"]').val(title);
    });

    // Shops autocomplete
    $('.select2').select2({
        width: 'resolve',
        selectionCssClass: 'survey-select2',
        dropdownCssClass: 'survey-select2-dropdown',
        placeholder: {
            id: '-1',
        }
    });

    if ($("#shop_id").length) {
        $("#shop_id").select2({
            width: 'resolve',
            selectionCssClass: 'survey-select2',
            dropdownCssClass: 'survey-select2-dropdown',
        });
    }

    // Toggle Experience date
    $('body').on('click', '.ToggleExpEnd', function(event) {
        $("#AddExpEnd").toggleClass('hide');
        $("#RemoveExpEnd").toggleClass('hide');
        $("#ExpDateStart").toggleClass('half-wd');
        $("#ExpEndField").toggle();
        $('input[name="experience_end"]').val('');
    });

    // Toggle Order field
    $('body').on('click', '.ToggleOrderRef', function(event) {
        $("#ShowOrderRef").toggleClass('hide');
        $("#RemoveOrderRef").toggleClass('hide');
        $("#OrderRefField").toggle();
    });
});
